import { render, staticRenderFns } from "./PixGatewayForm.vue?vue&type=template&id=4bfd3204"
import script from "./PixGatewayForm.vue?vue&type=script&lang=js"
export * from "./PixGatewayForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports